/**
 * Ошибка апскейла. Отдельным файлом, чтобы `measure-image.ts` и UI могли её
 * проверять, не подтягивая `upscale-image.ts` с созданием воркера.
 */
export type UpscaleFailureReason =
  /** Модель или wasm ORT не скачались, либо сессия не создалась. */
  | 'model-load'
  /** Модель упала посреди обработки. */
  | 'inference'
  /** В браузере нет `Worker` или `WebAssembly` — улучшать нечем. */
  | 'unsupported'
  /** Пользователь отменил обработку. */
  | 'aborted'
  /** Браузер не смог декодировать картинку. */
  | 'decode';

export class UpscaleImageError extends Error {
  constructor(
    readonly reason: UpscaleFailureReason,
    message?: string,
  ) {
    super(message ?? reason);
    this.name = 'UpscaleImageError';
  }
}
